import { render, staticRenderFns } from "./AccessControlForm.vue?vue&type=template&id=5c49f71e&"
import script from "./AccessControlForm.vue?vue&type=script&lang=js&"
export * from "./AccessControlForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports